import script from "./LanguageRadioButtons.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageRadioButtons.vue?vue&type=script&setup=true&lang=js"

import "./LanguageRadioButtons.vue?vue&type=style&index=0&id=965218bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-965218bc"]])

export default __exports__